/* eslint no-undef: 0 */
import {SearchServicesFactory} from '../../search/Services/factory.js'
import DealerErrorsFactory from '../Errors/factory.js'
import DealerMappersFactory from '../Mappers/factory.js'
import DealerRepositoriesFactory from '../Repositories/factory.js'
import {DealerRequestsFactory} from '../Requests/factory.js'
import DealerServicesFactory from '../Services/factory.js'
import {GetDealerUseCase} from './GetDealerUseCase.js'
import {GetPaginationSearchUrlDealerUseCase} from './GetPaginationSearchUrlDealerUseCase.js'
import {GetSearchRequestDealerUseCase} from './GetSearchRequestDealerUseCase.js'
import {GetSearchResultsDealerUseCase} from './GetSearchResultsDealerUseCase.js'
import {GetSearchUrlDealerUseCase} from './GetSearchUrlDealerUseCase.js'
import {GetTrackingPhoneDealerUseCase} from './GetTrackingPhoneDealerUseCase.js'

export default class DealerUseCasesFactory {
  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @return {GetTrackingPhoneDealerUseCase}
   */
  static getTrackingPhoneDealerUseCase = ({config}) =>
    new GetTrackingPhoneDealerUseCase({
      config,
      getTrackingPhoneDealerService: DealerServicesFactory.getTrackingPhoneDealerService({config}),
      fromParamsToTrackingPhoneRequestParamsValueObjectMapper:
        DealerMappersFactory.fromParamsToTrackingPhoneRequestParamsValueObjectMapper({config})
    })

  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @return {GetDealerUseCase}
   */
  static getDealerUseCase = ({config}) =>
    new GetDealerUseCase({
      config,
      getDealerService: DealerServicesFactory.getDealerService({config}),
      getDealerRequestFactory: DealerRequestsFactory.getDealerRequest
    })

  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @return {GetSearchResultsDealerUseCase}
   */
  static getSearchResultsDealerUseCase = ({config}) =>
    new GetSearchResultsDealerUseCase({
      config,
      getRequestSearchService: SearchServicesFactory.getRequestSearchService({
        config
      }),
      repository: DealerRepositoriesFactory.hTTPDealerRepository({config}),
      fromSearchToSearchResultsDealerRequestMapper: DealerMappersFactory.fromSearchToSearchResultsDealerRequestMapper({
        config
      })
    })

  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @return {GetSearchRequestDealerUseCase}
   */
  static getSearchRequestDealerUseCase = ({config}) =>
    new GetSearchRequestDealerUseCase({
      config,
      getRequestSearchService: SearchServicesFactory.getRequestSearchService({
        config
      })
    })

  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @return {GetSearchUrlDealerUseCase}
   */
  static getSearchUrlDealerUseCase = ({config}) =>
    new GetSearchUrlDealerUseCase({
      config,
      getUrlSearchService: SearchServicesFactory.getUrlSearchService({config})
    })

  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @return {GetPaginationSearchUrlDealerUseCase}
   */
  static getPaginationSearchUrlDealerUseCase = ({config}) =>
    new GetPaginationSearchUrlDealerUseCase({
      config,
      getUrlSearchService: SearchServicesFactory.getUrlSearchService({config}),
      getPaginationSearchUrlDealerErrorFactory: DealerErrorsFactory.getPaginationSearchUrlDealerError
    })
}
